import { MobileBaseField } from '../BaseField/models';

export const MobileDateTimeField = MobileBaseField.extend({
    validation: {
        'value.$date': {
            required: function (val, attr, attrs) {
                return this._is_required(val, attr, attrs);
            }
        }
    }
});
